import { render, staticRenderFns } from "./MovimentiMagazzinoView.vue?vue&type=template&id=46be589e&"
import script from "./MovimentiMagazzinoView.vue?vue&type=script&lang=js&"
export * from "./MovimentiMagazzinoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports